import { Component, OnInit } from '@angular/core';
import {SeoService} from '../../../../services/seo/seo.service';

@Component({
  selector: 'app-public-policy-society',
  templateUrl: './public-policy-society.component.html',
  styleUrls: ['./public-policy-society.component.scss']
})
export class PublicPolicySocietyComponent implements OnInit {

  constructor(private seo: SeoService) { }

  ngOnInit(): void {
    this.seo.setMeta('Public Policy Society');
  }

}
